import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-service-save-success',
  templateUrl: './modal-service-save-success.component.html',
  styleUrls: ['./modal-service-save-success.component.scss']
})
export class ModalServiceSaveSuccessComponent {

  OrderDetails: string = ""

  constructor(private BsModalRef: BsModalRef, private router: Router) { }

  closeModal(): void {
    this.router.navigate(['/home']);
    this.BsModalRef.hide();
  }

  goToDetails(): void {
    if (this.OrderDetails) {
      this.router.navigate([`/active-routes/${this.OrderDetails}/detail`]);
      this.BsModalRef.hide();
    } else {
      this.closeModal()
    }
  }
}
